/**
 * PremiumPortraitFrame — Cadre doré "tableau de maître" pour portraits spécialistes.
 *
 * Esprit : cabinet d'affaires, banque privée, étude notariale de standing.
 * Anti-bling : or brossé / champagne / laiton satiné, jamais miroir.
 *
 * Deux niveaux :
 *   - verified=true  → cadre doré premium + badge "Spécialiste référencé"
 *   - verified=false → cadre neutre sauge (couleur secondaire CONFILEX)
 *
 * Le composant englobe la photo (ou les initiales) et applique :
 *   - bordure 3-6px (responsive) en or brossé via background gradient
 *   - liseré interne subtil pour la profondeur
 *   - ombre légère
 *   - micro-illumination au survol (250ms)
 *
 * Compatible carrousel : pas d'animation lourde, transitions ciblées.
 */
import { ShieldCheck } from "lucide-react";

export default function PremiumPortraitFrame({
  verified = false,
  className = "",
  showBadge = true,
  children,
}) {
  return (
    <div
      data-testid={verified ? "premium-frame-verified" : "premium-frame-neutral"}
      className={`relative isolate group/frame ${className}`}
    >
      {/* Couche cadre — gradient brossé doré pour les référencés, sauge sinon */}
      <div
        aria-hidden
        className={[
          "absolute inset-0 rounded-lg pointer-events-none z-0 transition-[box-shadow,filter] duration-300 ease-out",
          verified
            ? "premium-frame-gold group-hover/frame:premium-frame-gold-glow"
            : "premium-frame-neutral",
        ].join(" ")}
      />
      {/* Photo / contenu — légèrement encarté pour laisser voir la bordure */}
      <div className="relative z-10 m-[4px] sm:m-[5px] rounded-[3px] overflow-hidden">
        {children}
      </div>
      {/* Badge "Spécialiste référencé" — discret, en bas à gauche */}
      {verified && showBadge && (
        <div
          className="absolute left-2 bottom-2 z-10 flex items-center gap-1 px-2 py-0.5 rounded-sm bg-night/85 backdrop-blur text-[10px] uppercase tracking-[0.15em] text-copper font-medium"
          data-testid="referenced-badge"
        >
          <ShieldCheck className="w-3 h-3" />
          Spécialiste référencé
        </div>
      )}
    </div>
  );
}
